import { PATHS } from '../constants/paths'

import { setToken } from './sessionStorage'
import { history } from './history'

export const loginRedirect = ({ token, path, navigate }) => {
  setToken(token)
  navigate(path || PATHS.ROOT)
}
